/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_Top_CenterInputs */

const en_input_position_top_center = /** @type {(inputs: Input_Position_Top_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top Center`)
};

const fr_input_position_top_center = /** @type {(inputs: Input_Position_Top_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haut Centre`)
};

const de_input_position_top_center = /** @type {(inputs: Input_Position_Top_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oben Mitte`)
};

const it_input_position_top_center = /** @type {(inputs: Input_Position_Top_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro superiore`)
};

const ru_input_position_top_center = /** @type {(inputs: Input_Position_Top_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Верхний центр`)
};

const es_input_position_top_center = /** @type {(inputs: Input_Position_Top_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro superior`)
};

const zh_cn2_input_position_top_center = /** @type {(inputs: Input_Position_Top_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`顶部中心`)
};

const ja_input_position_top_center = /** @type {(inputs: Input_Position_Top_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上中央`)
};

const hi_input_position_top_center = /** @type {(inputs: Input_Position_Top_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शीर्ष केंद्र`)
};

const pt_pt2_input_position_top_center = /** @type {(inputs: Input_Position_Top_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro superior`)
};

/**
* | output |
* | --- |
* | "Top Center" |
*
* @param {Input_Position_Top_CenterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_top_center = /** @type {((inputs?: Input_Position_Top_CenterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_Top_CenterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_input_position_top_center(inputs)
	if (locale === "de") return de_input_position_top_center(inputs)
	if (locale === "it") return it_input_position_top_center(inputs)
	if (locale === "ru") return ru_input_position_top_center(inputs)
	if (locale === "es") return es_input_position_top_center(inputs)
	if (locale === "zh-CN") return zh_cn2_input_position_top_center(inputs)
	if (locale === "ja") return ja_input_position_top_center(inputs)
	if (locale === "hi") return hi_input_position_top_center(inputs)
	if (locale === "pt-PT") return pt_pt2_input_position_top_center(inputs)
	return en_input_position_top_center(inputs)
});